function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Button, Input, Select, Upload, Radio, Alert, Switch } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import { Upload as UploadIc } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var AddMail = function AddMail(_ref) {
  var handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(file),
    _useState8 = _slicedToArray(_useState7, 2),
    file = _useState8[0],
    setFile = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    userOptions = _useState0[0],
    setUserOptions = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    secret = _useState10[0],
    setSecret = _useState10[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedType = _useState12[0],
    setSelectedType = _useState12[1];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append("subject", values.subject);
    formData.append("sender", values.sender);
    formData.append("priority", values.priority);
    formData.append("type", values.type);
    formData.append("file", file);
    formData.append("user_id", Common.currentUser.id);
    formData.append('destinator_id', values.destinator_id);
    formData.append('secret', secret);
    axios.post(Common.baseApiUrl + "addmail", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  var handleSecretChange = function handleSecretChange(v) {
    var s = v == true ? 1 : 0;
    setSecret(s);
  };
  var typeOptions = [{
    label: "Entrant",
    value: 0
  }, {
    label: "Sortant",
    value: 1
  }];
  var handleTypeOptionsChange = function handleTypeOptionsChange(v) {
    setSelectedType(v);
  };
  useEffect(function () {
    form.setFieldsValue({
      priority: 1,
      type: selectedType
    });
  }, []);
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getplatformusers/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUserOptions([]);
        response.data.users.forEach(function (u) {
          setUserOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: u.id,
              label: "".concat(u.prenom, " ").concat(u.nom, " - ").concat(u.job)
            }]);
          });
        });
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      banner: true,
      message: errorMessage
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Form, {
      form: form,
      onFinish: onFinish,
      layout: "vertical",
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Type",
              name: "type",
              rules: [{
                required: true,
                message: "Champ obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Select, {
                options: typeOptions,
                onChange: handleTypeOptionsChange
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 9,
            md: 9,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: selectedType == 0 ? "Provenance" : "Destination",
              name: "sender",
              rules: [{
                required: true,
                message: "Champ obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Input, {})
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 7,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Objet",
              name: "subject",
              rules: [{
                required: true,
                message: "Champ obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Input, {})
            })
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Transferer \xE0",
              name: "destinator_id",
              rules: [{
                required: true,
                message: "Champ obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Select, {
                options: userOptions
              })
            })
          })]
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 6,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Priorit\xE9",
              name: "priority",
              rules: [{
                required: true,
                message: "Veuillez assigner une priorité"
              }],
              children: /*#__PURE__*/_jsxs(Radio.Group, {
                defaultValue: 1,
                buttonStyle: "solid",
                children: [/*#__PURE__*/_jsx(Radio.Button, {
                  value: 0,
                  children: "Faible"
                }), /*#__PURE__*/_jsx(Radio.Button, {
                  value: 1,
                  children: "Normale"
                }), /*#__PURE__*/_jsx(Radio.Button, {
                  value: 2,
                  children: "Elev\xE9e"
                }), /*#__PURE__*/_jsx(Radio.Button, {
                  value: 3,
                  children: "Urgent"
                })]
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: " ",
              children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  icon: /*#__PURE__*/_jsx(UploadIc, {
                    size: 20
                  }),
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Joindre le courrier"
                  })
                })
              }))
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 3,
            children: /*#__PURE__*/_jsx(Form.Item, {
              label: "Confidentiel",
              children: /*#__PURE__*/_jsx(Switch, {
                defaultChecked: secret == 1,
                onChange: handleSecretChange
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                size: "large",
                htmlType: "submit",
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "ENREGISTRER"
                })
              })
            })
          })
        })]
      })
    })]
  });
};
export default AddMail;